import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import Card from "../components/custom/Card";
import CollapseCard from "../components/custom/CollapseCard";
import { apiUrl } from "../config";
import { useParams } from "react-router-dom";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { AppDispatch } from "../redux/store";
import {
  fetchEmployeesAction,
  fetchEmployeesByIdAction,
} from "../redux/actions/employeeActions";
import {
  addAttachmentAction,
  deleteAttachmentAction,
  fetchAttachmentByIdAction,
  fetchAttachmentsAction,
} from "../redux/actions/empAttachAction";

const EmployeeAttachment = () => {
  const { id: employeeId } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const employeeList = useSelector((state: StoreState) => state.employee);
  const attachments = useSelector(
    (state: StoreState) => state.employeeAttachment || [],
  );
  console.log(attachments);

  type AttachmentField = {
    attachmentTitle: string;
    attachmentUrl: File | null;
  };

  const [attachmentFields, setAttachmentFields] = useState<AttachmentField[]>([
    { attachmentTitle: "", attachmentUrl: null },
  ]);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const fileRefs = useRef<(HTMLInputElement | null)[]>([]);

  const employee = employeeList.find(
    (emp) => String(emp.employeeId) === employeeId,
  );
  const attachment = attachments.filter(
    (emp) => String(emp.employeeId) === employeeId,
  );

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchEmployeesAction());
      dispatch(fetchAttachmentsAction());
    }
  }, [dispatch, employeeId]);

  const handleAttachmentNameChange = (index: number, value: string) => {
    setAttachmentFields((prev) => {
      const updatedFields = [...prev];
      updatedFields[index].attachmentTitle = value;
      return updatedFields;
    });
  };

  const handleFileChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      setAttachmentFields((prev) => {
        const updatedFields = [...prev];
        updatedFields[index].attachmentUrl = file;
        return updatedFields;
      });
    }
  };

  const addAttachmentField = () => {
    setAttachmentFields([
      ...attachmentFields,
      { attachmentTitle: "", attachmentUrl: null },
    ]);
  };

  const removeAttachmentField = (index: number) => {
    setAttachmentFields(attachmentFields.filter((_, i) => i !== index));
     fileRefs.current.splice(index, 1);
  };

  const handleUpload = async () => {
    if (!employeeId) return;

    for (const field of attachmentFields) {
      if (!field.attachmentTitle || !field.attachmentUrl) {
        toast.error("Please fill all fields and select a file.");
        return;
      }

      const formData = new FormData();
      formData.append("employeeId", employeeId);
      formData.append("attachmentTitle", field.attachmentTitle);
      formData.append("attachmentUrl", field.attachmentUrl);

      try {
        await dispatch(addAttachmentAction(formData));
        toast.success("File uploaded successfully");
      } catch (err) {
        toast.error(String(err));
      }
    }

    setAttachmentFields([{ attachmentTitle: "", attachmentUrl: null }]);
    fileRefs.current.forEach((ref) => {
  if (ref) ref.value = "";
});
    dispatch(fetchAttachmentByIdAction(employeeId));
  };

  const handleView = (url: string) => {
    if (url) {
      window.open(`${apiUrl}/${url}`, "_blank");
    } else {
      toast.error("Invalid URL for the attachment.");
    }
  };

  const openDeleteConfirmation = (id: number) => {
    setSelectedId(id);
    setShowDeleteConfirmation(true);
  };

  const confirmDeleteHandler = async () => {
    try {
      await dispatch(deleteAttachmentAction(selectedId));
      toast.success("Attachment deleted successfully");
      setShowDeleteConfirmation(false);
      if (employeeId) {
        dispatch(fetchAttachmentByIdAction(employeeId));
      }
    } catch (err) {
      toast.error("Failed to delete attachment");
    }
  };

  return (
    <Main>
      <PageContainer title="Employee Attachments">
        <CollapseCard title="Upload Attachment">
          <div className="row">
            {employee && (
              <div className="col-md-6">
                <img
                  src={
                    employee.photoUrl ? `${apiUrl}/${employee.photoUrl}` : ""
                  }
                  alt={employee.name}
                  className="student-thumbnail"
                  style={{
                    objectFit: "contain",
                    height: "100px",
                    width: "100px",
                  }}
                />
                <h6>Name: {employee.name}</h6>
                <h6>Employee ID: {employee.employeeId}</h6>
                <h6>Mobile: {employee.mobileNumber}</h6>
                <h6>Email: {employee.emailId}</h6>
                <h6>Status: {employee.status}</h6>
              </div>
            )}
          </div>

          <div className="col mt-3 mb-3 d-flex justify-content-end">
            <Button variant="success" onClick={addAttachmentField}>
              <FaPlus /> Add Another Attachment
            </Button>
          </div>
          <div>
            {attachmentFields.map((field, index) => (
              <div className="row" key={index}>
                <div className="col-md-4">
                  <label>Attachment Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={field.attachmentTitle}
                    onChange={(e) =>
                      handleAttachmentNameChange(index, e.target.value)
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label>PDF File *</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="application/pdf"
                    onChange={(e) => handleFileChange(index, e)}
                     ref={(el) => (fileRefs.current[index] = el)}
                  />
                </div>
                <div className="col-md-2 mt-4">
                  {index > 0 && (
                    <Button
                      variant="danger"
                      onClick={() => removeAttachmentField(index)}
                    >
                      <FaMinus />
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="m-4 d-flex justify-content-end">
            <Button
              onClick={handleUpload}
              style={{ backgroundColor: "#10296C", color: "#fff" }}
            >
              Upload
            </Button>
          </div>
        </CollapseCard>

        <CollapseCard title="Attachments List">
          <div className="container-fluid">
            <table className="table table-striped">
              <thead style={{ backgroundColor: "#10296C", color: "#fff" }}>
                <tr>
                  <th>S.No</th>
                  <th>Attachment Name</th>
                  <th>File</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {attachment.map((attachment, index) => (
                  <tr key={attachment.id}>
                    <td>{index + 1}</td>
                    <td>{attachment.attachmentTitle}</td>
                    <td>
                      <Button
                        className="btn-sm"
                        onClick={() =>
                          typeof attachment.attachmentUrl === "string"
                            ? handleView(attachment.attachmentUrl)
                            : toast.error("Invalid URL for the attachment.")
                        }
                        style={{ backgroundColor: "#10296C", color: "#fff" }}
                      >
                        View
                      </Button>
                    </td>
                    <td>
                      <Button
                        className="btn btn-danger btn-sm"
                        onClick={() => openDeleteConfirmation(attachment.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CollapseCard>

        <ToastContainer />
        <>
          <Modal
            show={showDeleteConfirmation}
            onHide={() => setShowDeleteConfirmation(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>Are you sure you want to delete this attachment?</>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                Cancel
              </Button>
              <Button variant="danger" onClick={confirmDeleteHandler}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      </PageContainer>
    </Main>
  );
};

export default EmployeeAttachment;
